module.exports = __webpack_public_path__ + "img/drol.9e82682b.png";